__webpack_require__.p = "/coinsight/";